import { render, staticRenderFns } from "./TifVentanaGeneralOperacionesIndex.vue?vue&type=template&id=f6b968a6"
import script from "./TifVentanaGeneralOperacionesIndex.vue?vue&type=script&lang=js"
export * from "./TifVentanaGeneralOperacionesIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports